import { Table, Typography, Modal, Button} from "antd"
import { goBoxCsvSampleData } from "../../../data"
const {Text}= Typography

const CSVFormatGuideModal= ({visible, onClose})=>{
    const data= [...goBoxCsvSampleData]
    const columns = [
        {
            title: <Text>serial #</Text>,
            dataIndex: 'serialNo',
            key: 'serialNo',
        },
        {
            title: <Text>Mac Address</Text>,
            dataIndex: "macAddress",
            key: "macAddress",
        }
    ]
    return (
        <Modal
            title="CSV Format Guide"
            centered
            open={visible}
            onCancel={onClose}
            footer={null}
            width={950}
        >
            <Table
                size='large'
                columns={columns} 
                dataSource={data}     
                pagination={{ 
                    hideOnSinglePage: true, 
                    total: data?.length,
                    pageSize: 10,
                    defaultPageSize: 10,
                    size: "default",
                    pageSizeOptions:['20', '50', '100'],
                    showTotal: total => <Button>Total: {total}</Button>
                }}
            />
        </Modal>
    )
}
export {CSVFormatGuideModal}